import VehiclesManagerDashboard from './VehiclesManagerDashboard';
export default  VehiclesManagerDashboard;



// WEBPACK FOOTER //
// ./src/components/App/VehiclesManagerDashboard/index.js